const CHARGE_ALLOCATION_STATUS = {
  UNREVIEWED: {
    label: 'Awaiting Review',
    key: 'UNREVIEWED',
    color: 'var(--status_approved)',
  },
  OPEN: {
    label: 'Open',
    key: 'O',
    color: 'var(--status_transaction_created)',
  },
  PENDING: {
    label: 'Pending',
    key: 'P',
    color: 'var(--status_purchased)',
  },
  CLEARED: {
    label: 'Cleared',
    key: 'C',
    color: 'var(--status_received)',
  },
  EXCLUDED: {
    label: 'Excluded',
    key: 'EXCLUDED',
    color: 'var(--status_rejected)',
  },
};

const CHARGE_ALLOCATION_STATUS_KEYS = {
  UNREVIEWED: 'UNREVIEWED',
  O: 'OPEN',
  P: 'PENDING',
  C: 'CLEARED',
  EXCLUDED: 'EXCLUDED',
};

const getChargeAllocationStatus = (key) => {
  let statusKey = CHARGE_ALLOCATION_STATUS_KEYS[key];
  return (
    (statusKey && CHARGE_ALLOCATION_STATUS[statusKey]) || {
      key: key,
      label: key,
    }
  );
};

const getChargeAllocationStatusLabel = (key) => {
  let statusObject =
    key && CHARGE_ALLOCATION_STATUS[CHARGE_ALLOCATION_STATUS_KEYS[key]];
  return statusObject?.label || '';
};

const LINE_ITEM_STATUS = {
  // Added to a request
  OPEN: {
    label: 'Open',
    key: 'OPEN',
    color: 'var(--status_approved)',
  },
  // Added to a transaction
  PENDING: {
    label: 'Pending',
    key: 'PENDING',
    color: 'var(--status_transaction_created)',
  },
  // Purchased
  PURCHASED: {
    label: 'Purchased',
    key: 'PURCHASED',
    color: 'var(--status_purchased)',
  },
  // Received
  RECEIVED: {
    label: 'Received',
    key: 'RECEIVED',
    color: 'var(--status_received)',
  },
};

const getLineItemStatus = (key) => {
  return key ? LINE_ITEM_STATUS[key] || key : {};
};

const TRANSACTION_TYPE = {
  // BACK_GROUND_CHECK: 'Background Check',
  // CAMPUS_ORDER: 'Campus Order',
  // CHECK: 'Check',
  CREDIT_CARD: 'Credit Card',
  DEPOSIT: 'Deposit',
  ELECTRONIC: 'Electronic',
  // ELECTRONIC_INVOICE: 'Electronic Invoice',
  GENERAL_STORES: 'General Stores',
  INVOICE: 'Invoice',
  JOURNAL_ENTRY: 'Journal Entry',
  // JOURNAL_REQUEST: 'Journal Request',
  // LIMITED_PURCHASE_ORDER: 'Limited Purchase Order',
  // MAINTENANCE: 'Maintenance',
  NEB_FREEZER: 'NEB Freezer',
  OTHER: 'Other',
  PCARD: 'P-Card',
  PAYMENT_REQUEST: 'Payment Request',
  // SERVICE_CONTRACT: 'Service Contract',
  // PURCHASE_ORDER: 'Purchase Order',
  REQUISITION: 'Requisition',
  USHOP: 'uShop',
  // UNKNOWN: 'Unknown',
  // WIRE_TRANSFER: 'Wire Transfer',
};

const TRANSACTION_CATEGORY = {
  EXPENSE: 'Expense',
  REVENUE: 'Revenue',
};

const getTransactionType = (key) => {
  return key ? TRANSACTION_TYPE[key] || key : '';
};

const getTransactionCategory = (key) => {
  return key ? TRANSACTION_CATEGORY[key] || key : '';
};

const MISMATCHED_CORE_WARNING_TEXT =
  'Warning: Charge account associated with a different core than the transaction.';

module.exports = {
  CHARGE_ALLOCATION_STATUS,
  getChargeAllocationStatus,
  getChargeAllocationStatusLabel,
  LINE_ITEM_STATUS,
  getLineItemStatus,
  TRANSACTION_TYPE,
  TRANSACTION_CATEGORY,
  getTransactionType,
  getTransactionCategory,
  MISMATCHED_CORE_WARNING_TEXT,
};
